import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { base_url } from '../../utils/config'

// ▶ fetch all bookings
export const fetchBookings = createAsyncThunk(
  'hyperDeliveryList/fetchBookings',
  async (_, { getState, rejectWithValue }) => {
    const token = getState().auth.token
    if (!token) return rejectWithValue('Not authenticated')
    try {
      const { data } = await axios.get(
        `${base_url}/api/borzo/bookings`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      return data
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to load deliveries')
    }
  }
)

// ▶ fetch one booking + order
export const fetchBookingDetail = createAsyncThunk(
  'hyperDeliveryList/fetchBookingDetail',
  async (orderId, { getState, rejectWithValue }) => {
    const token = getState().auth.token
    if (!token) return rejectWithValue('Not authenticated')
    try {
      const { data } = await axios.get(
        `${base_url}/api/borzo/booking/${orderId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      // data: { booking, order }
      return data
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to load booking details')
    }
  }
)

const slice = createSlice({
  name: 'hyperDeliveryList',
  initialState: {
    // list
    bookings: [],
    loading:  false,
    error:    null,
    // detail
    bookingDetail: null,
    orderDetail:   null,
    detailLoading: false,
    detailError:   null
  },
  extraReducers: builder =>
    builder
      // ─── list ───
      .addCase(fetchBookings.pending, state => {
        state.loading = true
        state.error   = null
      })
      .addCase(fetchBookings.fulfilled, (state, { payload }) => {
        state.loading  = false
        state.bookings = payload
      })
      .addCase(fetchBookings.rejected, (state, { payload }) => {
        state.loading = false
        state.error   = payload
      })

      // ─── detail ───
      .addCase(fetchBookingDetail.pending, state => {
        state.detailLoading = true
        state.detailError   = null
      })
      .addCase(fetchBookingDetail.fulfilled, (state, { payload }) => {
        state.detailLoading  = false
        state.bookingDetail  = payload.booking
        state.orderDetail    = payload.order
      })
      .addCase(fetchBookingDetail.rejected, (state, { payload }) => {
        state.detailLoading = false
        state.detailError   = payload
      })
})

export default slice.reducer
